import { cx } from "@suse-o11y/class-variance";
import React from "react";

export interface TextProps {
	className?: string;
	color?: string;
	fontSize: undefined | number;
	children: React.ReactNode;
}

export const Text: React.FC<TextProps> = ({ className, color, fontSize, ...props }) => (
	<div
		className={cx("flex items-center justify-center font-text text-grey-800 leading-tight", className)}
		style={{ color, fontSize }}
		{...props}
	/>
);
